import styled from 'styled-components';
import { Loader as LoaderLayoutComponent } from '@playbookux/playbook-web-core';

export const Loader = styled(LoaderLayoutComponent)``;

export const ContainerLoader = styled.div`
  display: flex;
  height: 100%;
  justify-content: center;
  align-items: center;
`;
